<app-status-pill
    [statusTooltip]="statusTooltip"
    [statusName]="statusName"
    [statusColor]="statusColor"
    [size]="size"></app-status-pill>
